import { PersistentNotificationFeedKey, RequestStatus, defaults, entities } from 'typed/api';
import { Action, UntypedAction } from 'typed/actions';
import { combineReducers, entityLoadAllReducer, switchReducers } from './utils';
import { deepAssign } from 'typed/utils';

const
    ns = defaults.NotificationReportPaginationSlice,
    nf: entities.NotificationFeed = {
        filter: defaults.NotificationFilter,
        notifications: ns,
        Custom: ns.Custom
    },
    fs: { [k: string]: entities.NotificationFeed; } = {},

    feed = switchReducers(nf,
        (state = nf, action: Action<'INITIALIZE_NOTIFICATION_FEED'>) => action.type === 'INITIALIZE_NOTIFICATION_FEED' ? nf : state,
        combineReducers(nf, {
            filter: (state = nf.filter, action: Action<'SEARCH_NOTIFICATIONS_SLICE'>) =>
                action.type === 'SEARCH_NOTIFICATIONS_SLICE' ? deepAssign(state, action.payload.filter) : state,
            notifications: switchReducers(ns,
                entityLoadAllReducer(ns, 'SEARCH_NOTIFICATIONS_SLICE'),
                (state = ns, action: Action<'SEARCH_NOTIFICATIONS_SLICE'>) =>
                    action.type === 'SEARCH_NOTIFICATIONS_SLICE' ?
                        action.payload.status === RequestStatus.SUCCEEDED && !state.Custom.visibleNewCount ?
                            deepAssign(state, { Custom: { visibleNewCount: action.payload.response.NewCount } }) :
                            state :
                        state,
                (state = ns, action: Action<'TOUCH_ALL_NOTIFICATIONS'>) =>
                    action.type === 'TOUCH_ALL_NOTIFICATIONS' ?
                        deepAssign(state, {
                            NewCount: action.payload.status === RequestStatus.SUCCEEDED ? 0 : state.NewCount,
                            Custom: {
                                visibleNewCount: action.payload.status === RequestStatus.UNSYNCED ? 0 : state.Custom.visibleNewCount,
                                touchStatus: action.payload.status
                            }
                        }) :
                        state,
                (state = ns, action: Action<'ADD_STAKEHOLDER_COMMENT'>) =>
                    action.type === 'ADD_STAKEHOLDER_COMMENT' && action.payload.status === RequestStatus.SUCCEEDED ? ns : state,
                (state = ns, action: UntypedAction) => action.type === 'ADD_ENTITY_CHANGE' && !(action.change as any)?.EntityType.startsWith('Workshop') ? ns : state
            )
        }),
        (state = nf, action: Action<'DROP_NOTIFICATION_FEED'>) =>
            action.type === 'DROP_NOTIFICATION_FEED' ?
                action.payload.notificationFeedKey in PersistentNotificationFeedKey ?
                    nf :
                    (null as unknown as typeof nf /* TODO combineReducers accepts null as return value, but never passes it as state; another special reducer type?*/) :
                state,
        (state = nf, _action: UntypedAction) => state && deepAssign(state, { Custom: state.notifications.Custom }) // so expiration reducer would drop the whole feed rather than corrupt it
    );


export default combineReducers({
    notificationFeeds: (state = fs, action: Parameters<typeof feed>[1]) => {
        if (!state || action.type === 'ADD_ENTITY_CHANGE' || action.type === 'TOUCH_ALL_NOTIFICATIONS' || action.type === 'ADD_STAKEHOLDER_COMMENT' || action.payload && 'notificationFeedKey' in action.payload) {
            const newState = { ...state };

            [...Object.keys(state || {}), ...Object.values(PersistentNotificationFeedKey), action.payload && action.payload.notificationFeedKey].filter(v => v).forEach((key: string) => {
                newState[key] =
                    (
                        !action.payload || !action.payload.notificationFeedKey || action.payload.notificationFeedKey === key ?
                            feed(state[key], action) :
                            state[key]
                    ) ||
                    (key in PersistentNotificationFeedKey ? nf : undefined);
            });

            return deepAssign(state, newState);
        }

        return state;
    }
});
